<template>
  <div
    class="section"
  >
    <div class="circle circle--primary circle--size-7">
      <div class="column--central">
        <div class="fs1 mv1">
          {{ spiderman.moment(appointment.date).format('MM/DD') }}
        </div>
        <div class="fs1 mv1">
          {{ appointment.clinic }}
        </div>
      </div>
    </div>
    <div class="column--central">
      <div class="mv2">
        {{ appointment.doctor }}
      </div>
      <div class="fs1 fc--secondary mv1">
        醫師
      </div>
    </div>
    <div class="column--central">
      <div class="row--central mv1">
        <div class="label bc--default ph3 pv1 fs1 mh1">
          {{ appointment.room }}
        </div>
      </div>
      <div class="fs1 fc--secondary mv1">
        {{ appointment.timeSlotName }}
        {{ appointment.startCheckInTime }} - {{ appointment.endCheckInTime }}
      </div>
    </div>
    <div class="column--central">
      <div class="fs4 fw2 fc--primary mv1">
        {{ appointment.waitingNumber }}
      </div>
      <div class="fs1 fc--secondary mv1">
        號碼
      </div>
    </div>
    <div class="column--central">
      <div
        @click="$emit('showCancelConfirmation')"
        class="circle circle--size-2 circle--secondary row--central"
      >
        <font-awesome-icon
          :icon="['fas', 'times']"
          class="fs1"
        />
      </div>
    </div>
  </div>
</template>

<script>
import spiderman from '@/spiderman/index';

export default {
  props: {
    appointment: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  emits: ['showCancelConfirmation'],
  setup() {
    return {
      spiderman,
    };
  },
};
</script>
